module.exports = __webpack_public_path__ + "img/350x625 Parcel.630ad7e4.jpg";